//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";

// custom pages
import Logo from "assets/img/logo.png";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import ThriveLogo from "assets/img/thrive-logo.png";
import IconButton from "@material-ui/core/IconButton";
import HSBanner from "assets/img/Banner-Image.png";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import LanguageSharpIcon from "@material-ui/icons/LanguageSharp";
import Grid from "@material-ui/core/Grid";

export default function TransferAdminConsentPending() {
  const { adminConsentPending,getAdminConsentStatus } = auth();

  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");
  const [usLink, setusLink] = useState("");

  const handleGetData = async () => {
    try {
      let res = await adminConsentPending({ token });
      if (res?.type == "success") {
        window.location.replace(res?.referrerUrl);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  useEffect(() => {
    handleGetAdminConsentStatus();
  }, []);

  const handleGetAdminConsentStatus = async () => {
    try {
      // setLoading(true);
      let res = await getAdminConsentStatus(token);
      if (res && res?.type == "success") {
       
        setusLink(res?.usLink)
        
      
        return;
      }
     
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
      <Grid container className={classes.gridContainer}>
        <Grid item sm={10} className={classes.flexGrid}>
          <div className={classes.logoImgDiv}>
            <img src={ThriveLogo} className={classes.logoImg} />
          </div>
        </Grid>
        <div className={classes.flexBoxDiv}>
          <Grid item className={classes.backToGrid}>
            <IconButton
              className={classes.globeIconBtn}
              onClick={() => window.open("https://www.henryschein.com")}
            >
              <LanguageSharpIcon className={classes.languageIcon} />
            </IconButton>
            <br />
            <div
              className={classes.backtoHendry}
              onClick={() => window.open("https://www.henryschein.com")}
            >
              Henry Schein <br /> <div>Dental</div>
            </div>
          </Grid>
        </div>
      </Grid>
      <div className={classes.HSBanner}>
        <img src={HSBanner} alt="" width="100%" height="" />
      </div>

      <div className={classes.mainDiv}>
        <Card className={classes.card}>
          <div className={classes.divText}>Activate Your Account</div>
          <div className={classes.divSubText}>
            Thank you for transferring. Thrive Rewards is a no-fee discount
            program intended for private dental practice and small group
            practices. For questions regarding eligibility, please contact
            Thrive Rewards Customer Service at 1-800-888-6684. By transferring
            in Thrive Rewards, you have read, understood and agree to the{" "}
            <a
              target="_blank"
              href={usLink}
            >
              [Terms & Conditions]
            </a>{" "}
            of this program.
            {token && (
              <div className={classes.consentBtnDiv}>
                <Button
                  className={classes.consentBtn}
                  onClick={() => {
                    history.push(`/transfer-admin-consent?token=${token}`, {
                      login: true,
                    });
                  }}
                >
                  Click to Activate
                </Button>
              </div>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
